import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')
const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffCrudOrders = () => import('./staff/crudOrders')
const ViewStaffCrudOrdersSellers = () => import('./staff/crudOrdersSeller')
const ViewStaffCrudOrdersCourses = () => import('./staff/crudOrdersCourses')
const ViewStaffConfiguration = () => import('./staff/configuration')
const ViewStaffReason = () => import('./staff/crudOrdersReason')
const ViewStaffMobileOrderCreate = () => import('./staff/mobileOrderCreate')
const ViewStaffOrderCuts = () => import('./staff/orderCuts')

Vue.use(Router)

// reference (access.view_reference / m_modules_permissions.reference) ->
// nombre de ruta. Fuente única, ver router/viewsRegistry.js.
const VIEWS = {
  dashboard: 'OrdersStaffDashboard',
  crudOrders: 'OrdersStaffCrudOrders',
  crudOrdersSeller: 'OrdersStaffCrudOrdersSellers',
  crudOrdersCourses: 'OrdersStaffCrudOrdersCourses',
  crudOrdersReason: 'OrdersStaffReason',
  mobileOrderCreate: 'OrdersStaffMobileOrderCreate',
  orderCuts: 'OrdersStaffOrderCuts',
  configuration: 'OrdersStaffConfiguration',
}

const router =
  [
    {
      path: '/st/orders',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: VIEWS.dashboard,
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Pedidos',
          }          
        }, 
        {
          path: 'products',
          name: VIEWS.crudOrders,
          component: ViewStaffCrudOrders,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de Pedidos',
          }
        },          
        {
          path: 'sellers-products',
          name: VIEWS.crudOrdersSeller,
          component: ViewStaffCrudOrdersSellers,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Gestión de Pedidos',
          }
        },                          
        {
          path: 'courses',
          name: VIEWS.crudOrdersCourses,
          component: ViewStaffCrudOrdersCourses,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Cursos Vendidos',
          }          
        },  

        {
          path: 'reason',
          name: VIEWS.crudOrdersReason,
          component: ViewStaffReason,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Motivos de Pedido',
          }
        },

        {
          path: 'mobile-create',
          name: VIEWS.mobileOrderCreate,
          component: ViewStaffMobileOrderCreate,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Nuevo Pedido',
          }
        },

        {
          path: 'cuts',
          name: VIEWS.orderCuts,
          component: ViewStaffOrderCuts,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: { title: 'Cortes de preparación y reparto' },
        },

        {
          path: 'configuration',
          name: VIEWS.configuration,
          component: ViewStaffConfiguration,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Configuración de Pedidos',
          }
        },  
      ]
    },

    {
      path: '/cu/orders',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/orders',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
export { VIEWS }
